module.exports = __webpack_public_path__ + "static/img/65.171c60bf.png";